import React, {useEffect} from "react";
import { NavItem, Nav } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import { loopBackDomain, loopBackPort } from "environment/environment";
import { withRouter } from 'react-router-dom';
import "assets/css/custom.css";
import { PostAPI } from "api/post";
const cookies = new Cookies();

const AdminNavbarLinks  = props => {

  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',

    }
  ]

    const notification = (
      <div>
        {/* <i className="fa fa-globe" />
        <b className="caret" />
        <span className="notification">0</span>
        <p className="hidden-lg hidden-md">Notification</p> */}
      </div>
    );


    const { t, i18n } = useTranslation();
    const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)


  async function  handleLanguageChange(language) {
      localStorage.setItem('i18nextLng', language);
      i18n.changeLanguage(language)
      const payload = {
        language: currentLanguageCode === 'en' ? 'english' : 'chinese'
      };
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/yml';
      let responseData = await PostAPI(url,payload);
      let responseDataJson = JSON.parse(responseData.data.data)
      localStorage.setItem('chineseSidebar', JSON.stringify(responseDataJson));
    }
  

  useEffect(()=>{
      let currentLang = localStorage.getItem('i18nextLng')
      i18n.changeLanguage(currentLang)
    },[])

    const logout = (e) => {
      const param = cookies.get('title');
      document.title = param.split('-')[0];
      cookies.remove('accessToken',{ path: '/' });
      cookies.remove('user_id',{ path: '/' });
      cookies.remove('userLocation_id',{ path: '/' });
      cookies.remove('userRole_name',{ path: '/' });
      cookies.remove('feature_id',{ path: '/' });
      cookies.remove('pagetype_id',{ path: '/' });
      cookies.remove('customer_type',{ path: '/' });
      cookies.remove('customer_id',{ path: '/' });
      cookies.remove('tabTitle',{ path: '/' });
      localStorage.removeItem('i18nextLng');
      localStorage.removeItem("newSidebar");
      props.history.push('/login');   
  }

    return (
      <div>
         <Nav pullRight>
        <NavItem eventKey={2}>
        <span style={{fontSize: '13px'}}>{t('logged')}   </span><span style={{color: 'white',fontSize: '15px'}}>{localStorage.getItem('email')}</span>
          </NavItem>
          <NavItem eventKey={4} href="#" onClick={e => logout(e) }>{t('logout')}
          </NavItem>
        </Nav>
      </div>
    );
  }


export default withRouter(AdminNavbarLinks);